import React, { Component, Fragment } from 'react'
import {withStyles, CircularProgress, Paper} from "@material-ui/core";
import firebase from '../../firebase'

import CreateNotification from './CreateNotification'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

const styles = theme => ({
    paper: {
        padding: 0,
        margin: theme.spacing(2),
        // height: '100%',
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
})

class Notifications extends Component {

    constructor(props) {
        super(props)

        this.state = {
            templates: [],
            loading: true
        }

        this.database = firebase.database().ref().child('notification-templates')
    }


    componentDidMount() {

        const prevTemplates = this.state.templates


        this.database.on('child_added', snap => {
            prevTemplates.unshift(snap.val())

            this.setState({
                loading: false,
                templates: prevTemplates
            })
        })

    }



    render() {
        const { classes } = this.props
        const { templates, loading } = this.state
        return (
            <Fragment>
                {loading ?
                    < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress>
                    :
                    <List>
                        {
                            templates.map((template) => {
                                return (
                                    <Paper className={classes.paper} key={template.title}>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                    <NotificationsActiveIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={template.title}
                                            secondary={template.body}
                                        />
                                        <ListItemSecondaryAction>
                                            <CreateNotification color="inherit" sendMode={true} notification={template} className={classes.menuButton} />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    </Paper>
                                )
                            })
                        }
                    </List>
                }
                <CreateNotification color="inherit" className={classes.menuButton} />
            </Fragment>
        )
    }
}

export default withStyles(styles)(Notifications)
